import React, { Component } from 'react';

export default class Searchable extends Component{
	constructor(props){
		super(props);
		this.state = {
			has_focus: false,
			multi_selected: []
		};
		this.generateResults = this.generateResults.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.listToggle = this.listToggle.bind(this);
		this.onFocusOut = this.onFocusOut.bind(this);
	}

	handleChange(e){
		this.props.handleChange(e.target.value);
	}

	handleSelect(e){
		e.persist();
		if ( !this.props.multiSelect ){
			this.setState({has_focus: false});
		}
		this.props.handleSelect(e.target.textContent);
	}

	onFocus(e){
		e.stopPropagation();
		if (!this.state.has_focus){
			this.setState({has_focus: true});
		}
	}

	listToggle(){
		this.setState({has_focus: !this.state.has_focus});
	}

	onFocusOut(e){
		if (this.props.onFocusOut){
			this.props.onFocusOut(e, this);
		} else if (this.state.has_focus){
			this.setState({has_focus: false});
		}
	}

	componentDidMount(){
		window.addEventListener('click', this.onFocusOut);
	}

	componentWillUnmount(){
		window.removeEventListener('click', this.onFocusOut);
	}

	generateResults(){
		let results_list;
		if ( this.state.has_focus ){
			const props = this.props;
			let results;
			if ( this.props.value && this.props.value.length > 1){
				let val = this.props.value.toString();
				let pattern = props.caseSensitive ? new RegExp('^'+val) : new RegExp('^'+val,'i');
				results = props.options.map((option,i) =>{
					if ( option.toString().match(pattern) ){
						return (
							<li
								key={i}
								index={i}
								value={option}
								onClick={this.handleSelect}
								className={props.listItemClass}
							>
								{option}
							</li>
						);
					}
				});
				
			} else {

				results = props.options.map((option,i) => {
					return (
						<li
							key={i}
							index={i}
							value={option}
							onClick={this.handleSelect}
							className={props.listItemClass}
						>
							{option}
						</li>
					);
				});
			}
			let top = props.style.input.height || '2rem';
			const zIndex = this.state.has_focus ? '2' : '0';
			const list_width = props.style.input.width || '100%';
			const list_container_style = {
				margin: '0',
				backgroundColor: props.style.list.backgroundColor,
				padding: '15px',
				border: '1px solid gray',
				broderTop: '0',
				borderRadius: '2px 2px 5px 5px',
				position: 'absolute',
				top: top,
				width: list_width,
				zIndex: zIndex
			};
			results_list =  <div style={list_container_style}>
								<ul style={props.style.list}>
									{results}
								</ul>
							</div>;
		}
		return results_list;
	}

	render(){
		const props = this.props;
		const results = this.generateResults();
		let inputStyle = {...props.style.input};
		const itemClass = props.listItemClass;
		const zIndex = this.state.has_focus ? '2' : '0';
		const disabled = this.props.disabled ? true : false;
		return(
			<div id={props.containerId} style={{position: 'relative', width: props.style.input.width}} onClick={this.onFocus}>	
				<div style={{position: 'relative', height: props.style.input.height, width: props.style.input.width}}>
					<input
						type="search"
						id={props.inputId}
						style={inputStyle}
						onChange={this.handleChange}
						onFocus={this.onFocus}
						value={this.props.value || ''}
						placeholder={props.placeholder}
						disabled={disabled}
						autoComplete="off"
					/>
					
				</div>
				{results}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/component/Searchable.js